export default __webpack_public_path__ + "static/media/beauty.9e44a0a7.svg";